export const wtNavItems = [
  { href: "/dashboard/applicant", label: "Overview", icon: "🧭" },
  { href: "/assessment/wt", label: "Wissenstest", icon: "🧪" },
  { href: "/dashboard/applicant/cv2", label: "CV", icon: "🧾" },
  { href: "/dashboard/account", label: "Account", icon: "🔐" },
];

export function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" });
}

export function statusLabel(status) {
  return status === "submitted" ? "Abgeschlossen" : "In Bearbeitung";
}
